import { render, staticRenderFns } from "./notice-edit.vue?vue&type=template&id=5012c0df&scoped=true"
import script from "./notice-edit.vue?vue&type=script&lang=js"
export * from "./notice-edit.vue?vue&type=script&lang=js"
import style0 from "./notice-edit.vue?vue&type=style&index=0&id=5012c0df&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5012c0df",
  null
  
)

export default component.exports